module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "breadcrumb"
  }, [_c('Breadcrumb', [_c('Breadcrumb-item', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("机侧题库")]), _vm._v(" "), _c('Breadcrumb-item', [_vm._v("口语题库")])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "search mex-search"
  }, [_c('Form', {
    attrs: {
      "show-message": false,
      "label-position": "top"
    }
  }, [_c('Row', {
    attrs: {
      "gutter": 16
    }
  }, [_c('i-col', {
    attrs: {
      "span": 12
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "题头 ID"
    }
  }, [_c('Input', {
    attrs: {
      "placeholder": "题头主键，精确匹配"
    },
    model: {
      value: (_vm.queryParam.id),
      callback: function($$v) {
        _vm.$set(_vm.queryParam, "id", $$v)
      },
      expression: "queryParam.id"
    }
  })], 1)], 1), _vm._v(" "), _c('i-col', {
    attrs: {
      "span": 12
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "业务键"
    }
  }, [_c('Input', {
    attrs: {
      "placeholder": "如 L1-L-U1-LR-Q001"
    },
    model: {
      value: (_vm.queryParam.businessCode),
      callback: function($$v) {
        _vm.$set(_vm.queryParam, "businessCode", $$v)
      },
      expression: "queryParam.businessCode"
    }
  })], 1)], 1), _vm._v(" "), _c('i-col', {
    attrs: {
      "span": 12
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "级别"
    }
  }, [_c('Select', {
    attrs: {
      "clearable": "",
      "placeholder": "请选择级别"
    },
    model: {
      value: (_vm.queryParam.levelCode),
      callback: function($$v) {
        _vm.$set(_vm.queryParam, "levelCode", $$v)
      },
      expression: "queryParam.levelCode"
    }
  }, _vm._l((_vm.levels), function(lv) {
    return _c('Option', {
      key: lv,
      attrs: {
        "value": lv
      }
    }, [_vm._v(_vm._s(lv))])
  }), 1)], 1)], 1), _vm._v(" "), _c('i-col', {
    attrs: {
      "span": 12
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "题型"
    }
  }, [_c('Select', {
    attrs: {
      "filterable": "",
      "clearable": "",
      "placeholder": "请选择题型"
    },
    model: {
      value: (_vm.queryParam.questionType),
      callback: function($$v) {
        _vm.$set(_vm.queryParam, "questionType", $$v)
      },
      expression: "queryParam.questionType"
    }
  }, _vm._l((_vm.questionTypes), function(t) {
    return _c('Option', {
      key: t,
      attrs: {
        "value": t
      }
    }, [_vm._v(_vm._s(_vm.questionTypeLabel(t, 'Speaking')))])
  }), 1)], 1)], 1), _vm._v(" "), _c('i-col', {
    attrs: {
      "span": 12
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "状态"
    }
  }, [_c('Select', {
    attrs: {
      "clearable": "",
      "placeholder": "请选择状态"
    },
    model: {
      value: (_vm.queryParam.status),
      callback: function($$v) {
        _vm.$set(_vm.queryParam, "status", $$v)
      },
      expression: "queryParam.status"
    }
  }, [_c('Option', {
    attrs: {
      "value": "PENDING_REVIEW"
    }
  }, [_vm._v("待审核 PENDING_REVIEW")]), _vm._v(" "), _c('Option', {
    attrs: {
      "value": "ONLINE"
    }
  }, [_vm._v("已上线 ONLINE")]), _vm._v(" "), _c('Option', {
    attrs: {
      "value": "OFFLINE"
    }
  }, [_vm._v("已下线 OFFLINE")]), _vm._v(" "), _c('Option', {
    attrs: {
      "value": "DISCARDED"
    }
  }, [_vm._v("已废弃 DISCARDED")])], 1)], 1)], 1), _vm._v(" "), _c('i-col', {
    attrs: {
      "span": 12
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "场景"
    }
  }, [_c('Select', {
    attrs: {
      "clearable": "",
      "placeholder": "请选择场景"
    },
    model: {
      value: (_vm.queryParam.examScene),
      callback: function($$v) {
        _vm.$set(_vm.queryParam, "examScene", $$v)
      },
      expression: "queryParam.examScene"
    }
  }, [_c('Option', {
    attrs: {
      "value": "GENERAL"
    }
  }, [_vm._v("通用 GENERAL")]), _vm._v(" "), _c('Option', {
    attrs: {
      "value": "PLACEMENT_ONLY"
    }
  }, [_vm._v("仅入门测 PLACEMENT_ONLY")]), _vm._v(" "), _c('Option', {
    attrs: {
      "value": "SUMMATIVE_ONLY"
    }
  }, [_vm._v("仅阶段测 SUMMATIVE_ONLY")])], 1)], 1)], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "mex-search-actions"
  }, [_c('Button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.search
    }
  }, [_vm._v("搜索")]), _vm._v(" "), _c('Button', {
    attrs: {
      "type": "warning"
    },
    on: {
      "click": _vm.openBatch
    }
  }, [_vm._v("批量编辑")]), _vm._v(" "), _c('Button', {
    attrs: {
      "type": "success"
    },
    on: {
      "click": _vm.openCreate
    }
  }, [_vm._v("新建")]), _vm._v(" "), _c('Button', {
    on: {
      "click": _vm.triggerImport
    }
  }, [_vm._v("导入口语")]), _vm._v(" "), _c('Button', {
    on: {
      "click": _vm.downloadTemplate
    }
  }, [_vm._v("下载模板")]), _vm._v(" "), _c('input', {
    ref: "fileInput",
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "type": "file",
      "accept": ".xls,.xlsx"
    },
    on: {
      "change": _vm.importData
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('List', {
    ref: "list",
    staticStyle: {
      "margin-top": "10px"
    },
    attrs: {
      "tableColumns": _vm.tableColumns,
      "listUrl": "/mex/speak/questions/list",
      "params": _vm.queryParam,
      "onLoading": _vm.onLoading,
      "reload": _vm.reload
    },
    on: {
      "on-selection-change": _vm.selectionChange
    }
  }), _vm._v(" "), _c('MexQuestionBatchModal', {
    attrs: {
      "bank": "speak",
      "selected-rows": _vm.selection
    },
    on: {
      "success": _vm.search
    },
    model: {
      value: (_vm.batchVisible),
      callback: function($$v) {
        _vm.batchVisible = $$v
      },
      expression: "batchVisible"
    }
  }), _vm._v(" "), _c('Modal', {
    attrs: {
      "title": "编辑口语题",
      "width": "960"
    },
    model: {
      value: (_vm.editVisible),
      callback: function($$v) {
        _vm.editVisible = $$v
      },
      expression: "editVisible"
    }
  }, [_c('p', [_vm._v("业务键 " + _vm._s(_vm.businessCode) + " / 版本 " + _vm._s(_vm.form.versionNo) + " / " + _vm._s(_vm.statusLabel(_vm.form.status)))]), _vm._v(" "), _c('div', {
    staticStyle: {
      "max-height": "70vh",
      "overflow-y": "auto",
      "padding-right": "8px"
    }
  }, [_c('Form', {
    attrs: {
      "label-width": 130
    }
  }, [(_vm.createMode) ? _c('Form-item', {
    attrs: {
      "label": "业务键"
    }
  }, [_c('Input', {
    attrs: {
      "placeholder": "如 L1-L-U1-LR-Q001"
    },
    model: {
      value: (_vm.businessCode),
      callback: function($$v) {
        _vm.businessCode = $$v
      },
      expression: "businessCode"
    }
  })], 1) : _vm._e(), _vm._v(" "), (!_vm.createMode && _vm.versions.length) ? _c('Form-item', {
    attrs: {
      "label": "历史版本"
    }
  }, [_c('Select', {
    on: {
      "on-change": _vm.switchVersion
    },
    model: {
      value: (_vm.selectedVersionId),
      callback: function($$v) {
        _vm.selectedVersionId = $$v
      },
      expression: "selectedVersionId"
    }
  }, _vm._l((_vm.versions), function(v) {
    return _c('Option', {
      key: v.id,
      attrs: {
        "value": v.id
      }
    }, [_vm._v(_vm._s(v.versionNo) + " / " + _vm._s(_vm.statusLabel(v.status)))])
  }), 1)], 1) : _vm._e(), _vm._v(" "), _c('Row', {
    attrs: {
      "gutter": 12
    }
  }, [_c('i-col', {
    attrs: {
      "span": 8
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "技能"
    }
  }, [_c('Select', {
    attrs: {
      "transfer": ""
    },
    model: {
      value: (_vm.form.skill),
      callback: function($$v) {
        _vm.$set(_vm.form, "skill", $$v)
      },
      expression: "form.skill"
    }
  }, [_c('Option', {
    attrs: {
      "value": "Speaking"
    }
  }, [_vm._v("口语 Speaking")])], 1)], 1)], 1), _vm._v(" "), _c('i-col', {
    attrs: {
      "span": 8
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "级别"
    }
  }, [_c('Input', {
    attrs: {
      "placeholder": "如 L1.0"
    },
    model: {
      value: (_vm.form.levelCode),
      callback: function($$v) {
        _vm.$set(_vm.form, "levelCode", $$v)
      },
      expression: "form.levelCode"
    }
  })], 1)], 1), _vm._v(" "), _c('i-col', {
    attrs: {
      "span": 8
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "题型"
    }
  }, [_c('Select', {
    attrs: {
      "filterable": "",
      "transfer": "",
      "placeholder": "检索已有题型"
    },
    model: {
      value: (_vm.form.questionType),
      callback: function($$v) {
        _vm.$set(_vm.form, "questionType", $$v)
      },
      expression: "form.questionType"
    }
  }, _vm._l((_vm.editTypeOptions), function(t) {
    return _c('Option', {
      key: t.value,
      attrs: {
        "value": t.value
      }
    }, [_vm._v(_vm._s(t.label))])
  }), 1)], 1)], 1), _vm._v(" "), _c('i-col', {
    attrs: {
      "span": 8
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "场景"
    }
  }, [_c('Select', {
    model: {
      value: (_vm.form.examScene),
      callback: function($$v) {
        _vm.$set(_vm.form, "examScene", $$v)
      },
      expression: "form.examScene"
    }
  }, [_c('Option', {
    attrs: {
      "value": "GENERAL"
    }
  }, [_vm._v("通用 GENERAL")]), _vm._v(" "), _c('Option', {
    attrs: {
      "value": "PLACEMENT_ONLY"
    }
  }, [_vm._v("仅入门测 PLACEMENT_ONLY")]), _vm._v(" "), _c('Option', {
    attrs: {
      "value": "SUMMATIVE_ONLY"
    }
  }, [_vm._v("仅阶段测 SUMMATIVE_ONLY")])], 1)], 1)], 1), _vm._v(" "), _c('i-col', {
    attrs: {
      "span": 8
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "子技能英文"
    }
  }, [_c('Select', {
    attrs: {
      "filterable": "",
      "clearable": "",
      "transfer": "",
      "placeholder": "选择题库已有子技能"
    },
    on: {
      "on-change": _vm.onSubSkillEnChange
    },
    model: {
      value: (_vm.form.subSkillEn),
      callback: function($$v) {
        _vm.$set(_vm.form, "subSkillEn", $$v)
      },
      expression: "form.subSkillEn"
    }
  }, _vm._l((_vm.subSkillEnOptions), function(t) {
    return _c('Option', {
      key: 'en-' + t.value,
      attrs: {
        "value": t.value
      }
    }, [_vm._v(_vm._s(t.label))])
  }), 1)], 1)], 1), _vm._v(" "), _c('i-col', {
    attrs: {
      "span": 8
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "子技能中文"
    }
  }, [_c('Select', {
    attrs: {
      "filterable": "",
      "clearable": "",
      "transfer": "",
      "placeholder": "选择题库已有子技能"
    },
    on: {
      "on-change": _vm.onSubSkillCnChange
    },
    model: {
      value: (_vm.form.subSkillCn),
      callback: function($$v) {
        _vm.$set(_vm.form, "subSkillCn", $$v)
      },
      expression: "form.subSkillCn"
    }
  }, _vm._l((_vm.subSkillCnOptions), function(t) {
    return _c('Option', {
      key: 'cn-' + t.value,
      attrs: {
        "value": t.value
      }
    }, [_vm._v(_vm._s(t.label))])
  }), 1)], 1)], 1), _vm._v(" "), _c('i-col', {
    attrs: {
      "span": 8
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "交互类型"
    }
  }, [_c('Input', {
    attrs: {
      "placeholder": "如 speak / record，可空"
    },
    model: {
      value: (_vm.form.interactionType),
      callback: function($$v) {
        _vm.$set(_vm.form, "interactionType", $$v)
      },
      expression: "form.interactionType"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('Form-item', {
    attrs: {
      "label": "中文指令"
    }
  }, [_c('Input', {
    attrs: {
      "placeholder": "给孩子看的中文指令"
    },
    model: {
      value: (_vm.form.instructionCn),
      callback: function($$v) {
        _vm.$set(_vm.form, "instructionCn", $$v)
      },
      expression: "form.instructionCn"
    }
  })], 1), _vm._v(" "), _c('Form-item', {
    attrs: {
      "label": "英文指令"
    }
  }, [_c('Input', {
    attrs: {
      "placeholder": "给孩子看的英文指令"
    },
    model: {
      value: (_vm.form.instructionEn),
      callback: function($$v) {
        _vm.$set(_vm.form, "instructionEn", $$v)
      },
      expression: "form.instructionEn"
    }
  })], 1), _vm._v(" "), _c('Form-item', {
    attrs: {
      "label": "题干脚本"
    }
  }, [_c('Input', {
    attrs: {
      "type": "textarea",
      "rows": 2,
      "placeholder": "口语题干脚本，可空"
    },
    model: {
      value: (_vm.form.script),
      callback: function($$v) {
        _vm.$set(_vm.form, "script", $$v)
      },
      expression: "form.script"
    }
  })], 1), _vm._v(" "), _c('Form-item', {
    attrs: {
      "label": "题干"
    }
  }, [_c('Input', {
    attrs: {
      "type": "textarea",
      "rows": 3,
      "placeholder": "题目正文"
    },
    model: {
      value: (_vm.form.stem),
      callback: function($$v) {
        _vm.$set(_vm.form, "stem", $$v)
      },
      expression: "form.stem"
    }
  })], 1), _vm._v(" "), _c('Row', {
    attrs: {
      "gutter": 12
    }
  }, [_c('i-col', {
    attrs: {
      "span": 12
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "题干音频"
    }
  }, [_c('Input', {
    attrs: {
      "placeholder": "音频地址，可空"
    },
    model: {
      value: (_vm.form.stemAudio),
      callback: function($$v) {
        _vm.$set(_vm.form, "stemAudio", $$v)
      },
      expression: "form.stemAudio"
    }
  }), _vm._v(" "), _c('MexAssetPreview', {
    attrs: {
      "path": _vm.form.stemAudio,
      "skill": _vm.form.skill || 'Speaking',
      "bank": "speak",
      "accept": "audio/*"
    },
    on: {
      "input": function($event) {
        _vm.form.stemAudio = $event
      }
    }
  })], 1)], 1), _vm._v(" "), _c('i-col', {
    attrs: {
      "span": 12
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "题干图"
    }
  }, [_c('Input', {
    attrs: {
      "placeholder": "图片地址，可空"
    },
    model: {
      value: (_vm.form.stemImage),
      callback: function($$v) {
        _vm.$set(_vm.form, "stemImage", $$v)
      },
      expression: "form.stemImage"
    }
  }), _vm._v(" "), _c('MexAssetPreview', {
    attrs: {
      "path": _vm.form.stemImage,
      "skill": _vm.form.skill || 'Speaking',
      "bank": "speak",
      "accept": "image/*"
    },
    on: {
      "input": function($event) {
        _vm.form.stemImage = $event
      }
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('Form-item', {
    attrs: {
      "label": "示范音频"
    }
  }, [_c('Input', {
    attrs: {
      "placeholder": "标准作答音频地址，可空"
    },
    model: {
      value: (_vm.form.answerAudioSample),
      callback: function($$v) {
        _vm.$set(_vm.form, "answerAudioSample", $$v)
      },
      expression: "form.answerAudioSample"
    }
  }), _vm._v(" "), _c('MexAssetPreview', {
    attrs: {
      "path": _vm.form.answerAudioSample,
      "skill": _vm.form.skill || 'Speaking',
      "bank": "speak",
      "accept": "audio/*"
    },
    on: {
      "input": function($event) {
        _vm.form.answerAudioSample = $event
      }
    }
  })], 1), _vm._v(" "), _c('Form-item', {
    attrs: {
      "label": "答案/跟读文本"
    }
  }, [_c('Input', {
    attrs: {
      "type": "textarea",
      "rows": 2,
      "placeholder": "跟读或标准作答文本，如 apple"
    },
    model: {
      value: (_vm.form.answerKey),
      callback: function($$v) {
        _vm.$set(_vm.form, "answerKey", $$v)
      },
      expression: "form.answerKey"
    }
  })], 1), _vm._v(" "), _c('Form-item', {
    attrs: {
      "label": "完整参考作答"
    }
  }, [_c('Input', {
    attrs: {
      "type": "textarea",
      "rows": 2,
      "placeholder": "完整示范答案，可空"
    },
    model: {
      value: (_vm.form.referenceAnswerFull),
      callback: function($$v) {
        _vm.$set(_vm.form, "referenceAnswerFull", $$v)
      },
      expression: "form.referenceAnswerFull"
    }
  })], 1), _vm._v(" "), _c('Row', {
    attrs: {
      "gutter": 12
    }
  }, [_c('i-col', {
    attrs: {
      "span": 8
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "满分"
    }
  }, [_c('Input', {
    attrs: {
      "placeholder": "单题满分，如 2"
    },
    model: {
      value: (_vm.form.fullScore),
      callback: function($$v) {
        _vm.$set(_vm.form, "fullScore", $$v)
      },
      expression: "form.fullScore"
    }
  })], 1)], 1), _vm._v(" "), _c('i-col', {
    attrs: {
      "span": 8
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "星级"
    }
  }, [_c('Input', {
    attrs: {
      "placeholder": "1-5 星"
    },
    model: {
      value: (_vm.form.difficultyLevel),
      callback: function($$v) {
        _vm.$set(_vm.form, "difficultyLevel", $$v)
      },
      expression: "form.difficultyLevel"
    }
  })], 1)], 1), _vm._v(" "), _c('i-col', {
    attrs: {
      "span": 8
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "抽题权重"
    }
  }, [_c('Input', {
    attrs: {
      "placeholder": "现稿多为 0.5"
    },
    model: {
      value: (_vm.form.adaptiveWeight),
      callback: function($$v) {
        _vm.$set(_vm.form, "adaptiveWeight", $$v)
      },
      expression: "form.adaptiveWeight"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('Form-item', {
    attrs: {
      "label": "评分维度"
    }
  }, [_c('p', {
    staticClass: "mex-dim-hint"
  }, [_vm._v("口语 AI 三维权重，建议合计 100。空着保存时按准确 40 / 流利 30 / 完整 30。")]), _vm._v(" "), _c('div', {
    staticClass: "mex-dim-card"
  }, [_c('Form', {
    attrs: {
      "show-message": false,
      "label-position": "top"
    }
  }, [_c('Row', {
    attrs: {
      "gutter": 12
    }
  }, _vm._l((_vm.dimensions), function(d) {
    return _c('i-col', {
      key: d.key,
      attrs: {
        "span": 8
      }
    }, [_c('Form-item', {
      attrs: {
        "label": _vm.dimLabel(d.key)
      }
    }, [_c('Input-number', {
      staticStyle: {
        "width": "100%"
      },
      attrs: {
        "min": 0,
        "max": 100,
        "placeholder": "百分数，如 40"
      },
      model: {
        value: (d.weight),
        callback: function($$v) {
          _vm.$set(d, "weight", $$v)
        },
        expression: "d.weight"
      }
    })], 1)], 1)
  }), 1)], 1), _vm._v(" "), _c('p', {
    staticClass: "mex-dim-hint"
  }, [_vm._v("当前合计 " + _vm._s(_vm.dimSum))])], 1)]), _vm._v(" "), _c('Form-item', {
    attrs: {
      "label": "评分细则"
    }
  }, [_c('Input', {
    attrs: {
      "type": "textarea",
      "rows": 2,
      "placeholder": "口语评分细则，可空"
    },
    model: {
      value: (_vm.form.scoringRubric),
      callback: function($$v) {
        _vm.$set(_vm.form, "scoringRubric", $$v)
      },
      expression: "form.scoringRubric"
    }
  })], 1), _vm._v(" "), _c('Form-item', {
    attrs: {
      "label": "AI基准"
    }
  }, [_c('Input', {
    attrs: {
      "type": "textarea",
      "rows": 2,
      "placeholder": "音素/语速等 AI 评分基准，可空"
    },
    model: {
      value: (_vm.form.aiBenchmark),
      callback: function($$v) {
        _vm.$set(_vm.form, "aiBenchmark", $$v)
      },
      expression: "form.aiBenchmark"
    }
  })], 1), _vm._v(" "), _c('Form-item', {
    attrs: {
      "label": "解析"
    }
  }, [_c('Input', {
    attrs: {
      "type": "textarea",
      "rows": 2,
      "placeholder": "解析文案，可空"
    },
    model: {
      value: (_vm.form.explanation),
      callback: function($$v) {
        _vm.$set(_vm.form, "explanation", $$v)
      },
      expression: "form.explanation"
    }
  })], 1), _vm._v(" "), _c('Form-item', {
    attrs: {
      "label": "考点"
    }
  }, [_c('Input', {
    attrs: {
      "type": "textarea",
      "rows": 2,
      "placeholder": "考查点，可空"
    },
    model: {
      value: (_vm.form.examPoint),
      callback: function($$v) {
        _vm.$set(_vm.form, "examPoint", $$v)
      },
      expression: "form.examPoint"
    }
  })], 1), _vm._v(" "), _c('Form-item', {
    attrs: {
      "label": "备注"
    }
  }, [_c('Input', {
    attrs: {
      "type": "textarea",
      "rows": 2,
      "placeholder": "内部备注，可空"
    },
    model: {
      value: (_vm.form.remark),
      callback: function($$v) {
        _vm.$set(_vm.form, "remark", $$v)
      },
      expression: "form.remark"
    }
  })], 1), _vm._v(" "), _c('Form-item', {
    attrs: {
      "label": "常见错误"
    }
  }, [_c('Input', {
    attrs: {
      "type": "textarea",
      "rows": 2,
      "placeholder": "常见错误说明，可空"
    },
    model: {
      value: (_vm.form.commonMistakes),
      callback: function($$v) {
        _vm.$set(_vm.form, "commonMistakes", $$v)
      },
      expression: "form.commonMistakes"
    }
  })], 1), _vm._v(" "), _c('Form-item', {
    attrs: {
      "label": "知识点"
    }
  }, [_c('Input', {
    attrs: {
      "placeholder": "知识点路径，可空"
    },
    model: {
      value: (_vm.form.knowledgePointHierarchy),
      callback: function($$v) {
        _vm.$set(_vm.form, "knowledgePointHierarchy", $$v)
      },
      expression: "form.knowledgePointHierarchy"
    }
  })], 1), _vm._v(" "), _c('Row', {
    attrs: {
      "gutter": 12
    }
  }, [_c('i-col', {
    attrs: {
      "span": 8
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "能力编码"
    }
  }, [_c('Input', {
    attrs: {
      "placeholder": "如 SPE-01"
    },
    model: {
      value: (_vm.form.abilityDimensionCode),
      callback: function($$v) {
        _vm.$set(_vm.form, "abilityDimensionCode", $$v)
      },
      expression: "form.abilityDimensionCode"
    }
  })], 1)], 1), _vm._v(" "), _c('i-col', {
    attrs: {
      "span": 8
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "能力档"
    }
  }, [_c('Input', {
    attrs: {
      "placeholder": "内部能力档，可空"
    },
    model: {
      value: (_vm.form.scoreMappingLevel),
      callback: function($$v) {
        _vm.$set(_vm.form, "scoreMappingLevel", $$v)
      },
      expression: "form.scoreMappingLevel"
    }
  })], 1)], 1), _vm._v(" "), _c('i-col', {
    attrs: {
      "span": 8
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "课程单元"
    }
  }, [_c('Input', {
    attrs: {
      "placeholder": "对应课程单元，可空"
    },
    model: {
      value: (_vm.form.courseUnitMapping),
      callback: function($$v) {
        _vm.$set(_vm.form, "courseUnitMapping", $$v)
      },
      expression: "form.courseUnitMapping"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('Form-item', {
    attrs: {
      "label": "能力描述"
    }
  }, [_c('Input', {
    attrs: {
      "type": "textarea",
      "rows": 2,
      "placeholder": "报告用的能力描述，可空"
    },
    model: {
      value: (_vm.form.abilityDescription),
      callback: function($$v) {
        _vm.$set(_vm.form, "abilityDescription", $$v)
      },
      expression: "form.abilityDescription"
    }
  })], 1), _vm._v(" "), _c('Row', {
    attrs: {
      "gutter": 12
    }
  }, [_c('i-col', {
    attrs: {
      "span": 12
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "全国均分"
    }
  }, [_c('Input', {
    attrs: {
      "placeholder": "如 72.5，可空"
    },
    model: {
      value: (_vm.form.benchmarkNationalAvg),
      callback: function($$v) {
        _vm.$set(_vm.form, "benchmarkNationalAvg", $$v)
      },
      expression: "form.benchmarkNationalAvg"
    }
  })], 1)], 1), _vm._v(" "), _c('i-col', {
    attrs: {
      "span": 12
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "同城优秀均分"
    }
  }, [_c('Input', {
    attrs: {
      "placeholder": "如 85，可空"
    },
    model: {
      value: (_vm.form.benchmarkCityExcellentAvg),
      callback: function($$v) {
        _vm.$set(_vm.form, "benchmarkCityExcellentAvg", $$v)
      },
      expression: "form.benchmarkCityExcellentAvg"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('Form-item', {
    attrs: {
      "label": "提升建议"
    }
  }, [_c('Input', {
    attrs: {
      "type": "textarea",
      "rows": 2,
      "placeholder": "报告提升建议，可空"
    },
    model: {
      value: (_vm.form.improvementSuggestion),
      callback: function($$v) {
        _vm.$set(_vm.form, "improvementSuggestion", $$v)
      },
      expression: "form.improvementSuggestion"
    }
  })], 1), _vm._v(" "), _c('Form-item', {
    attrs: {
      "label": "练习推荐"
    }
  }, [_c('Input', {
    attrs: {
      "placeholder": "推荐练习，可空"
    },
    model: {
      value: (_vm.form.recommendedPractice),
      callback: function($$v) {
        _vm.$set(_vm.form, "recommendedPractice", $$v)
      },
      expression: "form.recommendedPractice"
    }
  })], 1), _vm._v(" "), _c('Form-item', {
    attrs: {
      "label": "前置知识"
    }
  }, [_c('Input', {
    attrs: {
      "placeholder": "前置知识，可空"
    },
    model: {
      value: (_vm.form.prerequisiteKnowledge),
      callback: function($$v) {
        _vm.$set(_vm.form, "prerequisiteKnowledge", $$v)
      },
      expression: "form.prerequisiteKnowledge"
    }
  })], 1), _vm._v(" "), _c('Form-item', {
    attrs: {
      "label": "掌握周期"
    }
  }, [_c('Input', {
    attrs: {
      "placeholder": "如 1-2周，可空"
    },
    model: {
      value: (_vm.form.learningCycle),
      callback: function($$v) {
        _vm.$set(_vm.form, "learningCycle", $$v)
      },
      expression: "form.learningCycle"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('Button', {
    on: {
      "click": function($event) {
        _vm.editVisible = false
      }
    }
  }, [_vm._v("取消")]), _vm._v(" "), _c('Button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.saveEdit
    }
  }, [_vm._v("保存")])], 1)])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-18a24630","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/mex/MexSpeakQuestionList.vue
// module id = 1655
// module chunks = 8